import {
  bitcoinTestnet,
  sepolia,
  dotTestnet,
  backspinEthereum,
  backspinArbitrum,
  arbitrumSepolia,
  backspinSolana,
  solanaDevnet,
  hubTestnet,
  backspinTron,
  tronTestnet,
  bscTestnet,
  backspinBsc,
} from '@/shared/assets/chains';
import { NATIVE_TOKEN_ADDRESS } from '@/shared/assets/tokens/constants';
import {
  type Token,
  type ChainflipToken,
  flip$,
  btc$,
  dot$,
  usdt$,
  eth$,
  usdc$,
  sol$,
  wbtc$,
  hubdot$,
  hubusdc$,
  hubusdt$,
  type AnyChainflipToken,
  trxusdt$,
  trx$,
  cbbtc$,
  bnb$,
  bscusdt$,
} from '.';

export const tbtc$ = {
  chain: bitcoinTestnet,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Test Bitcoin',
  symbol: 'tBTC',
  decimals: 8,
  chainflipId: 'Btc',
  assetAndChainName: 'tBTC',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const pdot$ = {
  chain: dotTestnet,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Test Polkadot',
  symbol: 'pDOT',
  decimals: 10,
  chainflipId: 'Dot',
  assetAndChainName: 'pDOT',
  isStablecoin: false,
} as const satisfies AnyChainflipToken;

export const tsol$ = {
  chain: solanaDevnet,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Test Solana',
  symbol: 'tSOL',
  decimals: 9,
  chainflipId: 'Sol',
  assetAndChainName: 'tSOL',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const bsol$ = {
  chain: backspinSolana,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Backspin Solana',
  symbol: 'bSOL',
  decimals: 9,
  chainflipId: 'Sol',
  assetAndChainName: 'bSOL',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const seth$ = {
  chain: sepolia,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Sepolia Ether',
  symbol: 'sETH',
  decimals: 18,
  chainflipId: 'Eth',
  assetAndChainName: 'sETH',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const sflip$ = {
  chain: sepolia,
  address: process.env.NEXT_PUBLIC_FLIP_CONTRACT_ADDRESS as string,
  name: 'Testnet FLIP',
  symbol: 'sFLIP',
  canonicalSymbol: 'FLIP',
  decimals: 18,
  chainflipId: 'Flip',
  assetAndChainName: 'sFLIP',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const susdc$ = {
  chain: sepolia,
  address: '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238',
  name: 'Sepolia USDC',
  symbol: 'sUSDC',
  canonicalSymbol: 'USDC',
  decimals: 6,
  chainflipId: 'Usdc',
  assetAndChainName: 'sUSDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const susdt$ = {
  chain: sepolia,
  address: '0x27CEA6Eb8a21Aae05Eb29C91c5CA10592892F584',
  name: 'Sepolia USDT',
  symbol: 'sUSDT',
  decimals: 6,
  chainflipId: 'Usdt',
  assetAndChainName: 'sUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const swbtc$ = {
  chain: sepolia,
  address: '0xaaf48bd21155efeff9ca3699659c96bc86539b49',
  name: 'Sepolia WBTC',
  symbol: 'sWBTC',
  decimals: 8,
  chainflipId: 'Wbtc',
  assetAndChainName: 'sWBTC',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const beth$ = {
  chain: backspinEthereum,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Backspin Ether',
  symbol: 'bETH',
  decimals: 18,
  chainflipId: 'Eth',
  assetAndChainName: 'bETH',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const bflip$ = {
  chain: backspinEthereum,
  address: '0x10C6E9530F1C1AF873a391030a1D9E8ed0630D26',
  name: 'Backspin Flip',
  symbol: 'bFLIP',
  canonicalSymbol: 'FLIP',
  decimals: 18,
  chainflipId: 'Flip',
  assetAndChainName: 'bFLIP',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const busdc$ = {
  chain: backspinEthereum,
  address: '0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0',
  name: 'Backspin USDC',
  symbol: 'bUSDC',
  canonicalSymbol: 'USDC',
  decimals: 6,
  chainflipId: 'Usdc',
  assetAndChainName: 'bUSDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const busdt$ = {
  chain: backspinEthereum,
  address: '0x0DCd1Bf9A1b36cE34237eEaFef220932846BCD82',
  name: 'Backspin USDT',
  symbol: 'bUSDT',
  canonicalSymbol: 'USDT',
  decimals: 6,
  chainflipId: 'Usdt',
  assetAndChainName: 'bUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const bwbtc$ = {
  chain: backspinEthereum,
  address: '0x67d269191c92Caf3cD7723F116c85e6E9bf55933',
  name: 'Backspin Wrapped Bitcoin',
  symbol: 'bWBTC',
  canonicalSymbol: 'WBTC',
  decimals: 8,
  chainflipId: 'Wbtc',
  assetAndChainName: 'bWBTC',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const barbusdc$ = {
  chain: backspinArbitrum,
  address: '0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9',
  name: 'Backspin arbUSDC',
  symbol: 'bUSDC',
  decimals: 6,
  chainflipId: 'ArbUsdc',
  assetAndChainName: 'bArbUSDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const barbusdt$ = {
  chain: backspinArbitrum,
  address: '0x9A676e781A523b5d0C0e43731313A708CB607508',
  name: 'Backspin arbUSDT',
  symbol: 'bUSDT',
  decimals: 6,
  chainflipId: 'ArbUsdt',
  assetAndChainName: 'bArbUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const barbeth$ = {
  chain: backspinArbitrum,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Backspin arbETH',
  symbol: 'bETH',
  decimals: 18,
  chainflipId: 'ArbEth',
  assetAndChainName: 'bArbETH',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const sarbusdc$ = {
  chain: arbitrumSepolia,
  address: '0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d',
  name: 'Sepolia arbUSDC',
  symbol: 'sUSDC',
  decimals: 6,
  chainflipId: 'ArbUsdc',
  assetAndChainName: 'sArbUSDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const sarbusdt$ = {
  chain: arbitrumSepolia,
  address: '0x3dd1A7A99CFa2554Da8b3483e6eD739120Fc35cB',
  name: 'Sepolia arbUSDT',
  symbol: 'sUSDT',
  decimals: 6,
  chainflipId: 'ArbUsdt',
  assetAndChainName: 'sArbUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const sarbeth$ = {
  chain: arbitrumSepolia,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Sepolia arbETH',
  symbol: 'sETH',
  decimals: 18,
  chainflipId: 'ArbEth',
  assetAndChainName: 'sArbETH',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const tsolusdc$ = {
  chain: solanaDevnet,
  address: '4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU',
  name: 'Test solUSDC',
  symbol: 'stUSDC',
  decimals: 6,
  chainflipId: 'SolUsdc',
  assetAndChainName: 'stSolUSDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const tsolusdt$ = {
  chain: solanaDevnet,
  address: 'FvuqJYh8YeEmarW5qkSrYeEgzaTKktgL3vhgBy2Csy4o',
  name: 'Test solUSDT',
  symbol: 'stUSDT',
  decimals: 6,
  chainflipId: 'SolUsdt',
  assetAndChainName: 'stSolUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const bsolusdc$ = {
  chain: backspinSolana,
  address: '24PNhTaNtomHhoy3fTRaMhAFCRj4uHqhZEEoWrKDbR5p',
  name: 'Backspin solUSDC',
  symbol: 'sbUSDC',
  decimals: 6,
  chainflipId: 'SolUsdc',
  assetAndChainName: 'sbSolUSDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const bsolusdt$ = {
  chain: backspinSolana,
  address: '8D5DryH5hA6s7Wf5AHXX19pNBwaTmMmvj4UgQGW2S8dF',
  name: 'Backspin solUSDT',
  symbol: 'sbUSDT',
  decimals: 6,
  chainflipId: 'SolUsdt',
  assetAndChainName: 'sbSolUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const hubpdot$ = {
  chain: hubTestnet,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Test Polkadot DOT',
  symbol: 'hDOT',
  decimals: 10,
  chainflipId: 'HubDot',
  assetAndChainName: 'tHubDOT',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const hubpusdc$ = {
  chain: hubTestnet,
  address: '1337',
  name: 'Test Polkadot USDC',
  symbol: 'hUSDC',
  canonicalSymbol: 'USDC',
  decimals: 6,
  chainflipId: 'HubUsdc',
  assetAndChainName: 'tHubUSDC',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const hubpusdt$ = {
  chain: hubTestnet,
  address: '1984',
  name: 'Test Polkadot USDT',
  symbol: 'hUSDT',
  canonicalSymbol: 'USDT',
  decimals: 6,
  chainflipId: 'HubUsdt',
  assetAndChainName: 'tHubUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const btrx$ = {
  chain: backspinTron,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Backspin Tron',
  symbol: 'bTRX',
  decimals: 6,
  chainflipId: 'Trx',
  assetAndChainName: 'bTRX',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const btrxusdt$ = {
  chain: backspinTron,
  address: 'TQ6iqCJLAGYgVFccmARRLUBoAGM5FeMGqz',
  name: 'Backspin Tron USDT',
  symbol: 'bTrxUSDT',
  canonicalSymbol: 'USDT',
  decimals: 6,
  chainflipId: 'TrxUsdt',
  assetAndChainName: 'bTrxUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const ntrx$ = {
  chain: tronTestnet,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Tron',
  symbol: 'nTRX',
  decimals: 6,
  chainflipId: 'Trx',
  assetAndChainName: 'nTRX',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const ntrxusdt$ = {
  chain: tronTestnet,
  address: 'TXYZopYRdj2D9XRtbG411XZZ3kM5VkAeBf',
  name: 'Nile Testnet Tron USDT',
  symbol: 'nTrxUSDT',
  canonicalSymbol: 'USDT',
  decimals: 6,
  chainflipId: 'TrxUsdt',
  assetAndChainName: 'nTrxUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const scbbtc$ = {
  chain: sepolia,
  address: '0xcbB7C0006F23900c38EB856149F799620fcb8A4a',
  name: 'Sepolia Coinbase Wrapped BTC',
  symbol: 'scbBTC',
  canonicalSymbol: 'cbBTC',
  decimals: 8,
  chainflipId: 'Cbbtc',
  assetAndChainName: 'scbBTC',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const bcbbtc$ = {
  chain: backspinEthereum,
  address: '0xE6E340D132b5f46d1e472DebcD681B2aBc16e57E',
  name: 'Backspin Coinbase Wrapped BTC',
  symbol: 'bcbBTC',
  canonicalSymbol: 'cbBTC',
  decimals: 8,
  chainflipId: 'Cbbtc',
  assetAndChainName: 'bcbBTC',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const tbnb$ = {
  chain: bscTestnet,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'BNB',
  symbol: 'tBNB',
  decimals: 18,
  chainflipId: 'Bnb',
  assetAndChainName: 'tBNB',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const tbscusdt$ = {
  chain: bscTestnet,
  address: '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd',
  name: 'BNB Chain Testnet USDT',
  symbol: 'tBscUSDT',
  canonicalSymbol: 'USDT',
  decimals: 18,
  chainflipId: 'BscUsdt',
  assetAndChainName: 'tBscUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const bbnb$ = {
  chain: backspinBsc,
  address: NATIVE_TOKEN_ADDRESS,
  name: 'Backspin BNB',
  symbol: 'bBNB',
  decimals: 18,
  chainflipId: 'Bnb',
  assetAndChainName: 'bBNB',
  isStablecoin: false,
} as const satisfies ChainflipToken;

export const bbscusdt$ = {
  chain: backspinBsc,
  address: '0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9',
  name: 'BNB Chain Backspin USDT',
  symbol: 'bBscUSDT',
  canonicalSymbol: 'USDT',
  decimals: 18,
  chainflipId: 'BscUsdt',
  assetAndChainName: 'bBscUSDT',
  isStablecoin: true,
} as const satisfies ChainflipToken;

export const getTokenKey = (token: Token | { address: string; chainId: string }) => {
  const chainId = 'chain' in token ? token.chain.id : token.chainId;
  return `${chainId}-${token.address}`.toLowerCase();
};

export const getMainnetTokenEquivalent = (token: Token) => {
  // load prices of mainnet token to get realistic prices for testnet token
  switch (getTokenKey(token)) {
    case getTokenKey(sflip$):
    case getTokenKey(bflip$):
      return flip$;
    case getTokenKey(tbtc$):
      return btc$;
    case getTokenKey(tsol$):
    case getTokenKey(bsol$):
      return sol$;
    case getTokenKey(pdot$):
      return dot$;
    case getTokenKey(susdt$):
    case getTokenKey(busdt$):
    case getTokenKey(bsolusdt$):
    case getTokenKey(tsolusdt$):
    case getTokenKey(barbusdt$):
    case getTokenKey(sarbusdt$):
      return usdt$;
    case getTokenKey(seth$):
    case getTokenKey(beth$):
    case getTokenKey(sarbeth$):
    case getTokenKey(barbeth$):
      return eth$;
    case getTokenKey(susdc$):
    case getTokenKey(busdc$):
    case getTokenKey(sarbusdc$):
    case getTokenKey(barbusdc$):
    case getTokenKey(tsolusdc$):
    case getTokenKey(bsolusdc$):
      return usdc$;
    case getTokenKey(swbtc$):
    case getTokenKey(bwbtc$):
      return wbtc$;
    case getTokenKey(hubpdot$):
      return hubdot$;
    case getTokenKey(hubpusdc$):
      return hubusdc$;
    case getTokenKey(hubpusdt$):
      return hubusdt$;
    case getTokenKey(btrx$):
    case getTokenKey(ntrx$):
      return trx$;
    case getTokenKey(btrxusdt$):
    case getTokenKey(ntrxusdt$):
      return trxusdt$;
    case getTokenKey(scbbtc$):
    case getTokenKey(bcbbtc$):
      return cbbtc$;
    case getTokenKey(tbnb$):
    case getTokenKey(bbnb$):
      return bnb$;
    case getTokenKey(tbscusdt$):
    case getTokenKey(bbscusdt$):
      return bscusdt$;
    default:
      return token;
  }
};

export default [
  tbtc$,
  tsol$,
  bsol$,
  beth$,
  seth$,
  bflip$,
  sflip$,
  busdc$,
  susdc$,
  pdot$,
  busdt$,
  susdt$,
  swbtc$,
  bwbtc$,
  barbusdc$,
  sarbusdc$,
  barbusdt$,
  sarbusdt$,
  sarbeth$,
  barbeth$,
  tsolusdc$,
  tsolusdt$,
  bsolusdc$,
  bsolusdt$,
  hubpdot$,
  hubpusdc$,
  hubpusdt$,
  btrx$,
  btrxusdt$,
  ntrx$,
  ntrxusdt$,
  scbbtc$,
  bcbbtc$,
  tbnb$,
  tbscusdt$,
  bbnb$,
  bbscusdt$,
];
